import _ from 'lodash';
import axios from "@/axios";

const state = {
  model: {},
  rows: [],
  count: 0,
  page: 1,
  loading: false,
  searchQuery: undefined,
};
const mutations = {
  ADD_ITEM(state, data) {
    state.rows.push(data);
  },
  LOADING(state, data) {
    state.loading = data;
  },
  SEARCH_QUERY_SET(state, data) {
    state.searchQuery = data;
  },
  FETCH(state, {rows , count, page}){
    state.rows = rows;
    state.count = count || 0;
    state.page = page || 1;
  },
  INJECT_LIST(state, {count, rows, page}) {
    state.count = count;
    state.page = page;
    state.rows = rows;
  }
};


const actions = {
  async remove({commit, dispatch}, {id}) {
    commit('LOADING', true);
    try {
      const {data} = await axios.delete('category/' + id);
      dispatch('category/fetch');
    } catch (e) {

      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async save({commit, state}, payload) {
    commit('LOADING', true);
    try {
      if (payload.id) {
        const {data} = await axios.put(`category/${payload.id}`, payload);
        return data;
      } else {
        const {data} = await axios.post(`category/`, payload);
        return data;
      }
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async fetch({commit, state}, data) {
    commit('LOADING', true);
    try {
      const {data} = await axios.get('category/', {params:{page:state.page, text_search:state.searchQuery}});
      commit('FETCH' , data);

    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  }
};
const getters = {};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
